import { Environment } from './environment.types';

export const environment = {
  production: true,
  useMockserver:false,
  environmentName: 'prod',
  authentication: {
    authority: 'https://login.microsoftonline.com/ f2be6b6c-07b6-460b-b5f1-5edf0c415098',  
    clientID: '63e5c26b-d2ca-4b3b-9c89-5c632d6f3aa9',
    scopes: [
        'api://63e5c26b-d2ca-4b3b-9c89-5c632d6f3aa9/Get.CRM.Data'
    ],
    redirectUri: 'https://crm.focuscapital.ie/dashboard',
    postLogoutRedirectUri: 'https://crm.focuscapital.ie/',
  }
};



// WEBPACK FOOTER //
// ./client/environments/environment.ts